"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfPaginatedDigestFeedResponseDto = instanceOfPaginatedDigestFeedResponseDto;
exports.PaginatedDigestFeedResponseDtoFromJSON = PaginatedDigestFeedResponseDtoFromJSON;
exports.PaginatedDigestFeedResponseDtoFromJSONTyped = PaginatedDigestFeedResponseDtoFromJSONTyped;
exports.PaginatedDigestFeedResponseDtoToJSON = PaginatedDigestFeedResponseDtoToJSON;
exports.PaginatedDigestFeedResponseDtoToJSONTyped = PaginatedDigestFeedResponseDtoToJSONTyped;
var DigestPaginationMetaDto_1 = require("./DigestPaginationMetaDto");
var SportDigestGroupDto_1 = require("./SportDigestGroupDto");
/**
 * Check if a given object implements the PaginatedDigestFeedResponseDto interface.
 */
function instanceOfPaginatedDigestFeedResponseDto(value) {
    if (!('data' in value) || value['data'] === undefined)
        return false;
    if (!('meta' in value) || value['meta'] === undefined)
        return false;
    return true;
}
function PaginatedDigestFeedResponseDtoFromJSON(json) {
    return PaginatedDigestFeedResponseDtoFromJSONTyped(json, false);
}
function PaginatedDigestFeedResponseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': (json['data'].map(SportDigestGroupDto_1.SportDigestGroupDtoFromJSON)),
        'meta': (0, DigestPaginationMetaDto_1.DigestPaginationMetaDtoFromJSON)(json['meta']),
    };
}
function PaginatedDigestFeedResponseDtoToJSON(json) {
    return PaginatedDigestFeedResponseDtoToJSONTyped(json, false);
}
function PaginatedDigestFeedResponseDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'data': (value['data'].map(SportDigestGroupDto_1.SportDigestGroupDtoToJSON)),
        'meta': (0, DigestPaginationMetaDto_1.DigestPaginationMetaDtoToJSON)(value['meta']),
    };
}
